import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createPlatformMutation } from '../clients';
import { createSessionResponseSchema } from '../types';

export type CreateSessionParams = {
	GameId: string;
	ProviderId: string;
	ReturnUrl: string;
	Device?: string;
	Lang?: string;
};

export const createSessionMutation = createPlatformMutation({
	params: declareParams<CreateSessionParams>(),
	request: {
		method: 'POST',
		url: '/json-rpc/create-session',
		body: (params) => params,
	},
	response: {
		contract: zodContract(createSessionResponseSchema),
	},
});
